import React from 'react'
import { graphql } from 'gatsby'

import * as styles from './section.module.scss'

import Content from '@/components/blocks-library/content/content'
import ContentImage from '@/components/blocks-library/content-image/content-image'
import MapBlock from '@/components/blocks-library/map/map'

const Section = (props) => {
  const { title, subtitle, section, codeId } = props
  const classId = codeId.replace(/-/g, '')
  const dynamicClass = styles[classId]
  if (!title && !subtitle && section.length === 0) {
    return <></>
  }
  return (
    <div className={`container ${dynamicClass}`}>
      {title && (
        <div className="row mb-lg-2">
          <div className="col">
            <h2>{title}</h2>
            <h3>{subtitle}</h3>
          </div>
        </div>
      )}
      <div className="row">
        {section.map((data, index) => {
          switch (data.__typename) {
            case 'DatoCmsContentImage':
              return <ContentImage key={`${data.id}-${index}`} {...data} />
            case 'DatoCmsContent':
              return <Content key={`${data.id}-${index}`} {...data} />
            case 'DatoCmsMap':
              return <MapBlock key={`${data.id}-${index}`} {...data} />
            default:
              return <></>
          }
        })}
      </div>
    </div>
  )
}

export default Section

export const query = graphql`
  fragment Section on DatoCmsSection {
    __typename
    id
    navigationLabel
    title
    subtitle
    section: content {
      __typename
      ... on DatoCmsContent {
        ...SectionContent
      }
      ... on DatoCmsContentImage {
        ...SectionContentImage
      }
      ... on DatoCmsMap {
        ...SectionMap
      }
    }
    codeId
  }
`
